<template>
  <v-dialog :value="value" @input="(aberto) => $emit('input', aberto)" width="560" persistent>
    <v-card>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(gerar)">
          <v-card-title class="text-h6">Relatório da Busca Ativa</v-card-title>

          <v-card-text>
            <e-label>Escola</e-label>
            <ValidationProvider name="Escola" rules="required" v-slot="{ errors }">
              <e-autocomplete
                :error-messages="errors"
                :items="escolas"
                :item-text="(escola) => escola.descricao"
                :item-value="(escola) => escola.id"
                v-model="escolaId"
                @change="turmasSelecionadas = []"
                placeholder="Selecione a escola"
                solo
              />
            </ValidationProvider>

            <e-label>Turmas</e-label>
            <e-autocomplete
              :items="turmasDaEscola"
              :item-text="(turma) => turma.descricao"
              :item-value="(turma) => turma.id"
              v-model="turmasSelecionadas"
              :disabled="!escolaId"
              label="Todas as turmas da escola"
              multiple
              chips
              deletable-chips
              small-chips
              clearable
              solo
            />
            <div class="text-caption grey--text mt-n4">
              Sem turma selecionada, o relatório sai com todas as turmas da escola, agrupadas.
            </div>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn color="secondary" type="button" small @click="fechar">Cancelar</v-btn>
            <v-btn color="primary" type="submit" :loading="gerando" small>
              <v-icon left small>mdi-file-pdf-box</v-icon>
              Gerar relatório
            </v-btn>
          </v-card-actions>
        </form>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EModalRelatorioBuscaAtiva",
  props: {
    value: { type: Boolean, default: false },
    escolas: { type: Array, default: () => [] },
    turmas: { type: Array, default: () => [] },
    escolaInicial: { type: Number, default: null },
    turmaInicial: { type: Number, default: null },
  },
  data() {
    return {
      escolaId: null,
      turmasSelecionadas: [],
      gerando: false,
    };
  },
  computed: {
    turmasDaEscola() {
      if (!this.escolaId) return [];
      return this.turmas.filter((turma) => turma.configuracao_id === this.escolaId);
    },
  },
  watch: {
    value(aberto) {
      if (aberto) {
        this.escolaId = this.escolaInicial ?? this.escolaDaTurma(this.turmaInicial);
        this.turmasSelecionadas = this.turmaInicial ? [this.turmaInicial] : [];
      }
    },
  },
  methods: {
    escolaDaTurma(turmaId) {
      if (!turmaId) return null;
      return this.turmas.find((turma) => turma.id === turmaId)?.configuracao_id ?? null;
    },
    fechar() {
      this.$emit("input", false);
    },
    async gerar() {
      this.gerando = true;
      try {
        await this.$services.buscaAtivaService.relatorio({
          escola_id: this.escolaId,
          turmas: this.turmasSelecionadas,
        });
        this.fechar();
      } catch (error) {
        this.$handleError(error);
      }
      this.gerando = false;
    },
  },
};
</script>
